import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Functionality } from '../context/Functionality';
import BlogTable from './BlogTable';
export default function EmployeeBlog() {
    const { getAllBlogs } = useContext(Functionality);
    const api = useRef(getAllBlogs); api.current = getAllBlogs;
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [attempt, setAttempt] = useState(0);
    const { state } = useLocation();
    useEffect(() => {
        let active = true;
        setLoading(true); setError('');
        api.current().catch(err => { if (active) setError(err.response?.data?.errMsg || 'Unable to load articles. Please try again.'); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [attempt]);
    return <section className="mt-16 md:mt-0">
        <h1 className="text-3xl font-bold">Blog posts</h1>
        <div className="blog-actions"><Link to="/add-blog">New article</Link></div>
        {state?.message && <p role="status">{state.message}</p>}
        {loading ? <p role="status">Loading articles…</p> : error ? <div><p role="alert">{error}</p><button onClick={() => setAttempt(value => value + 1)}>Retry</button></div> : <BlogTable />}
    </section>;
}
